module.exports = __webpack_public_path__ + "media/shared/assets/fonts/InterDisplay/InterDisplay-Regular-a4074fefb60f137f7974a3f2cadf655c.woff2";